/* eslint-disable */
import 'expose-loader?exposes=Tether!tether';

import 'bxslider/dist/jquery.bxslider.min';

import './selectors';
import './cart';
import './carrier';
import './address';
import './validate';

import Form from './components/form';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import $ from 'jquery';
/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  form.init();
});